import isEmpty from 'hs-lodash/isEmpty';
import { getApplicationDomain } from '../constants/apiEnvironments';
export const getLoginUrl = ({
  redirectUrl,
  email,
  hublet
} = {}) => {
  let search = redirectUrl && !isEmpty(redirectUrl) ? `?loginRedirectUrl=${encodeURIComponent(redirectUrl)}` : '';

  if (email && !isEmpty(redirectUrl)) {
    search = `${search}${search ? '&' : '?'}email=${encodeURIComponent(email)}`;
  }

  return `${getApplicationDomain(hublet)}/login${search}`;
};